import { render, staticRenderFns } from "./ProspectDetailModal.vue?vue&type=template&id=f2e6631c"
import script from "./ProspectDetailModal.vue?vue&type=script&lang=js"
export * from "./ProspectDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports